import { required, helpers } from 'vuelidate/lib/validators'
const phoneformat = helpers.regex('phoneformat', /^([+])?(([-() ])*(\d+)*)*$/)

export default [{
  "id": "first-name",
  "type": "input",
  "label": "First Name",
  "size": 50,
  "model": "firstName",
  "validation": {
    required
  },
  "errorMsg": [
    "Please enter your first name."
  ]
},
{
  "id": "last-name",
  "type": "input",
  "label": "Last Name",
  "size": 50,
  "model": "lastName",
  "validation": {
    required
  },
  "errorMsg": [
    "Please enter you last name."
  ]
},
{
  "id": "mobile1",
  "type": "input",
  "label": "Mobile Number",
  "size": 50,
  "model": "mobile1",
  "validation": {
    required,
    phoneformat
  },
  "errorMsg": [
    "Please enter a valid phone number.",
    "Please enter a valid phone number format."
  ]
},
{
  "id": "mobile2",
  "type": "input",
  "label": "Secondary Phone Number",
  "size": 50,
  "model": "mobile2",
  "validation": {
    phoneformat
  },
  "errorMsg": [
    "Please enter a valid phone number format."
  ]
},
{
  "id": "address1",
  "type": "input",
  "label": "Address Line 1 (Street address, House Number etc)",
  "size": 100,
  "model": "address1",
  "validation": {
    required
  },
  "errorMsg": [
    "Please enter your address."
  ]
},
{
  "id": "address2",
  "type": "input",
  "label": "Address Line 2 (Unit Number, Apartment, Suite, Floor etc)",
  "size": 100,
  "model": "address2"
},
{
  "id": "postal-code",
  "type": "input",
  "label": "Zip / Postal Code",
  "size": 50,
  "model": "postalCode",
  "validation": {
    required
  },
  "errorMsg": [
    "Please enter your postal code."
  ]
},
{
  "id": "country",
  "type": "text",
  "label": "Country/Region",
  "size": 50,
  "model": "countryName"
}
]